import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Overflow Menu
 */

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M10 2a2 2 0 11-4 0 2 2 0 014 0zm0 6a2 2 0 11-4 0 2 2 0 014 0zm-2 8a2 2 0 100-4 2 2 0 000 4z"
      fillRule="evenodd"
    />
  </Icon>
);
